// src/pages/AdminPage.tsx
import React from 'react';
import AdminPanel from '../components/admin/AdminPanel';

const AdminPage: React.FC = () => {
  return <AdminPanel />;
};

export default AdminPage;